import React, { useState } from 'react';
import { Box, Menu, MenuItem } from '@mui/material';
import CustomButton from './CustomButton';
import {  useTheme } from "@mui/material";
import { tokens } from "../theme";
const DownloadDropdownButton = ({ onFileTypeSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [anchorEl, setAnchorEl] = useState(null);


  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOptionSelect = (fileType) => {
    handleClose();
    onFileTypeSelected(fileType);
  };

  return (
    <Box>
      <CustomButton
                  btnBG={colors.grey[900]}
                  btnColor={colors.grey[100]}
                  btnStartIcon={
                    <img src="../../assets/common/Download.svg" width={22} />
                  }
                  btnEndIcon={
                    <img src="../../assets/common/Arrow-down.svg" height={8} />
                  }
                  btnTxt={"Download"}
                  onClick={handleClick}
                ></CustomButton>  
      
      
      {/* <Button
        variant="contained"
        onClick={handleClick}
        endIcon={<i className="fas fa-filter"></i>} // You can use your own filter icon
      >
        Filter
      </Button> */}



      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
        transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
        }}
      >
        <MenuItem onClick={() => handleOptionSelect('PDF')}>PDF</MenuItem>
        <MenuItem onClick={() => handleOptionSelect('XLS')}>XLS</MenuItem>
        <MenuItem onClick={() => handleOptionSelect('CSV')}>CSV</MenuItem>
    
      </Menu>
    </Box>
  );
};

export default DownloadDropdownButton;
